module.exports = __webpack_public_path__ + "img/money.0868f408.png";